/* esm.sh - scheduler@0.27.0 */
export * from "/*scheduler@0.27.0/esnext/scheduler.mjs";
export { default } from "/*scheduler@0.27.0/esnext/scheduler.mjs";
